var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('img',{style:(_vm.styles),attrs:{"src":_vm.src},on:{"click":_vm.previewHandler}}),_c('a-modal',{attrs:{"title":null,"visible":_vm.visible,"maskClosable":true,"footer":null,"width":'fit-content'},on:{"cancel":function($event){_vm.visible = false}}},[_c('p'),_c('img',{attrs:{"src":_vm.src}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }